export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_it-2612f8ad.png";